export default __webpack_public_path__ + "static/media/favicon_placeholder.14a2ccd6.svg";